
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { getUser } from './user.js';
import { writable } from 'svelte/store';
import { mapBy } from "./utils.js";

let userRequest;
let labels;
let unsubscribe;

export function getLabels() {

    if (!labels) {
        labels = writable([]);
        load();
    }
    return labels;
}
/**
 * Load all labels.
 */
export async function load() {
    if (!userRequest) {
        userRequest = getUser();
        userRequest.subscribe((u) => {
            u.then(() => get('labels/', token || DEV_TOKEN)
                .then(r => {
                    labels.set(r.data);
                })
                .catch(e => {
                    labels.set([]);
                }));
        });
    }
}

export async function loadAll(id, invitation) {

    if (invitation === undefined) {
        invitation = false;
    }

    return get(`labels/?wedding_id=${id}` + (invitation ? '&invitation' : ''), token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return mapBy(d, invitation ? "invitation_id" : "guest_id");
        })
        .catch(e => {
            return [];
        });
}

/**
 * Load labels for guest.
 */
export async function loadGuest(id) {
    return get(`labels/?guest_id=${id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

/**
 * Load labels for invitation.
 */
export async function loadInvitation(id) {
    return get(`labels/?invitation_id=${id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

/**
 * Create Label.
 */
export function create(name) {
    return post('labels/',
        {
            name: name
        }, token || DEV_TOKEN);
}

/**
 * Add Label
 */
export function add(id, label_id, isGuest) {

    if (isGuest === undefined) {
        isGuest = true;
    }

    if (isGuest) {
        return put('labels/',
            {
                guest_id: id,
                label_id: label_id
            }, token || DEV_TOKEN);
    } else {
        return put('labels/',
            {
                invitation_id: id,
                label_id: label_id
            }, token || DEV_TOKEN);
    }

}

/**
 * Delete Label
 */
export function deleteLabel(id, label_id, isGuest) {
    if (isGuest === undefined) {
        isGuest = true;
    }
    if (isGuest) {
        return del('labels/',
            {
                guest_id: id,
                label_id: label_id
            }, token || DEV_TOKEN);
    } else {

        return del('labels/',
            {
                invitation_id: id,
                label_id: label_id
            }, token || DEV_TOKEN);
    }

}

